import NumberTextFieldComponent from '@components/inputs/numberTextField/NumberTextField.component';
import { Sizes } from '@constants/sizes.constants';
import { Box, CardActionArea, Stack, Typography } from '@mui/material';
import { AuditOperationScheduleDto, CreateAuditOperation } from '@store/audits/audits-operation/audits-operation.model';
import { globalWeekDaysShort } from '@utils/dayjs.utils';
import { getTypeOf } from '@utils/getTypeOf';
import { useEffect, useState } from 'react';

interface AuditContainerProps {
    auditOperation?: CreateAuditOperation;
    updateAuditOperation: <T extends keyof CreateAuditOperation>(
        field: T,
        value: CreateAuditOperation[T]
    ) => void;
}

const WeeklyCollect = (props: AuditContainerProps) => {
    const { auditOperation, updateAuditOperation } = props;
    const [frequency, setFrequency] = useState<AuditOperationScheduleDto>();

    useEffect(() => {
        if (auditOperation?.schedule) {
            const frequencyitem: AuditOperationScheduleDto = getTypeOf<AuditOperationScheduleDto>(auditOperation.schedule);
            updateAuditOperation('frequency', {
                weeklyFrequencyNumber: frequencyitem.weeklyFrequencyNumber,
                daysOfWeek: frequencyitem.daysOfWeek
            });
            setFrequency(frequencyitem);
        }
    }, [auditOperation?.schedule, updateAuditOperation]);

    const handleWeeksChange = (value: number) => {
        updateAuditOperation('frequency', { weeklyFrequencyNumber: value });
    };

    function isDayInDaysOfWeek(daysOfWeek: string, day: string): boolean {
        const daysArray = daysOfWeek.split(',');
        return daysArray.includes(day);
    }

    function handleChangeDay(day: string) {
        const currDays = auditOperation?.frequency?.daysOfWeek || '';

        if (isDayInDaysOfWeek(currDays, day)) {
            const updatedDays = currDays
                .split(',')
                .filter(d => d !== day)
                .join(',');
            updateAuditOperation('frequency', { daysOfWeek: updatedDays });
            setFrequency({ ...frequency, daysOfWeek: updatedDays });
        } else {
            const days = currDays
                .split(',')
                .concat(day);
            const updatedDays = days.filter((element) => element !== '').join(',');
            updateAuditOperation('frequency', { daysOfWeek: updatedDays });
            setFrequency({ ...frequency, daysOfWeek: updatedDays });
        }
    }


    return (
        <>
            <Stack direction="row" spacing={2}>
                <Box width={Sizes.drawerInputLabelWidth} />
                <Stack spacing={2}>
                    <Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Typography fontSize={14} fontWeight="400">
                                Toutes les
                            </Typography>
                            <NumberTextFieldComponent
                                inputWidth={80}
                                pattern={new RegExp(/^(\d*|\d+)$/)}
                                handleChange={(value) => handleWeeksChange(value!)}
                                value={frequency?.weeklyFrequencyNumber ?? 0}
                            />
                            <Typography fontSize={14} fontWeight="400">
                                semaine(s) le
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack>
                        <Stack direction="row" spacing={1}>
                            {globalWeekDaysShort.map((day, dIndex) => (
                                <CardActionArea
                                    key={`day ${dIndex}`}
                                    aria-label="week-day"
                                    aria-selected={isDayInDaysOfWeek(frequency?.daysOfWeek ?? '', day)}
                                    onClick={() =>
                                        handleChangeDay(day)
                                    }
                                >
                                    {day}
                                </CardActionArea>
                            ))}
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
};

export default WeeklyCollect;
